/**
 * Tarzı Hayal – Shopify Theme JavaScript (Vanilla JS)
 */

// Shared helper: product titles/handles get concatenated straight into
// innerHTML strings all over this file. A title containing a quote or
// angle bracket (e.g. 24" Round Table) would otherwise break the markup.
function escapeHtml(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
window.escapeHtml = escapeHtml;

document.addEventListener('DOMContentLoaded', () => {
  // ── Global Preloader Control ─────────────────────────────────
  const globalLoader = document.getElementById('globalLoader');
  const hideLoader = () => {
    if (globalLoader) {
      globalLoader.classList.add('is-hidden');
    }
  };

  // Since theme.js runs deferred and this is inside DOMContentLoaded,
  // we hide the loader immediately (50ms) so the page feels lightning-fast
  // instead of waiting for slow images/third-party scripts to trigger window.load.
  setTimeout(hideLoader, 50);

  window.showGlobalLoader = () => {
    if (globalLoader) globalLoader.classList.remove('is-hidden');
  };
  window.hideGlobalLoader = hideLoader;

  // ── Scroll Reveal ──────────────────────────────────────────
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length > 0) {
    const revealObs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(el => revealObs.observe(el));
  }

  // ── Cart Drawer Modal ──────────────────────────────────────
  const cartCloseTriggers = document.querySelectorAll('[data-action="close-cart"]');
  const cartOverlay = document.querySelector('.cart-drawer-overlay');
  const cartPanel   = document.querySelector('.cart-drawer-panel');

  window.openCartDrawer = () => {
    cartOverlay?.classList.add('open');
    cartPanel?.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  window.closeCartDrawer = () => {
    cartOverlay?.classList.remove('open');
    cartPanel?.classList.remove('open');
    document.body.style.overflow = '';
  };

  cartCloseTriggers.forEach(btn => btn.addEventListener('click', window.closeCartDrawer));
  cartOverlay?.addEventListener('click', window.closeCartDrawer);


  // ── Search Drawer & Desktop Inline Trigger ────────────────
  const openSearchBtn = document.getElementById('openSearchBtn');
  const searchDrawer = document.getElementById('searchDrawer');
  const closeSearchBtn = document.getElementById('closeSearchBtn');
  const desktopSearchInput = document.getElementById('desktopSearchInput');
  const desktopSearchSuggestions = document.getElementById('desktopSearchSuggestions');
  const desktopSearchSuggestionsContent = document.getElementById('desktopSearchSuggestionsContent');
  const headerEl = document.getElementById('header');
  let desktopSearchTimeout = null;

  function getSearchLocaleConfig() {
    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : (window.location.pathname.startsWith('/en') ? '/en' : '')).replace(/\/$/, '');
    const isEn = rootUrl === '/en' || document.documentElement.lang === 'en' || window.location.pathname.startsWith('/en');
    return {
      rootUrl: rootUrl,
      isEn: isEn,
      searchUrl: rootUrl ? rootUrl + '/search' : '/search',
      suggestApiUrl: rootUrl ? rootUrl + '/search/suggest.json' : '/search/suggest.json'
    };
  }

  if (openSearchBtn) {
    // role="button" on a <div> gets no built-in keyboard activation —
    // bridge Enter/Space to the same click handling below.
    openSearchBtn.addEventListener('keydown', (e) => {
      if (e.target.tagName === 'INPUT') return;
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        openSearchBtn.click();
      }
    });

    openSearchBtn.addEventListener('click', (e) => {
      // Mobile View: Toggle Dropdown Drawer under header navbar
      if (window.innerWidth <= 768) {
        e.preventDefault();
        if (searchDrawer) {
          searchDrawer.classList.toggle('open');
          if (searchDrawer.classList.contains('open')) {
            if (headerEl) headerEl.classList.add('header--search-active');
            const mInput = document.getElementById('SearchInputLiquid');
            const mResults = document.getElementById('SearchContentResults');
            if (mInput) {
              mInput.focus();
              if (mInput.value.trim().length < 2 && mResults && typeof window.renderPopularDefaultContent === 'function') {
                window.renderPopularDefaultContent(mResults);
              }
            }
          } else {
            if (headerEl) headerEl.classList.remove('header--search-active');
          }
        }
        return;
      }

      // Desktop View: Inline slide-out search in header top row
      if (!openSearchBtn.classList.contains('is-active')) {
        if (e.target.tagName !== 'INPUT') {
          e.preventDefault();
          openSearchBtn.classList.add('is-active');
          if (headerEl) headerEl.classList.add('header--search-active');
          if (desktopSearchInput) {
            desktopSearchInput.style.display = 'inline-block';
            desktopSearchInput.focus();
            if (desktopSearchInput.value.trim().length < 2 && searchDrawer) {
              const searchResults = document.getElementById('SearchContentResults');
              if (typeof window.renderPopularDefaultContent === 'function') {
                window.renderPopularDefaultContent(searchResults);
              }
              searchDrawer.classList.add('open');
            }
          }
        }
      }
    });

    // Close desktop search when clicked outside
    document.addEventListener('click', (e) => {
      if (window.innerWidth > 768 && openSearchBtn && desktopSearchInput) {
        if (openSearchBtn.contains(e.target) || (searchDrawer && searchDrawer.contains(e.target))) {
          return;
        }
        openSearchBtn.classList.remove('is-active');
        desktopSearchInput.style.display = 'none';
        if (headerEl) headerEl.classList.remove('header--search-active');
        if (searchDrawer) {
          searchDrawer.classList.remove('open');
        }
      }
    });
  }

  window.cleanSearchQuery = function(text) {
    if (!text) return '';
    var cleaned = text.trim().toLowerCase();
    
    var dictionary = {
      'koltuu': 'koltuk',
      'di nlenme koltuu': 'dinlenme koltuğu',
      'dinlenme koltuu': 'dinlenme koltuğu',
      'di nlenme': 'dinlenme'
    };
    
    if (dictionary[cleaned]) {
      return dictionary[cleaned];
    }
    
    cleaned = cleaned.replace(/koltuu/g, 'koltuk');
    cleaned = cleaned.replace(/di\snlenme/g, 'dinlenme');
    
    // Capitalize first letter of each word
    return cleaned.replace(/\b\w/g, function(l) { return l.toUpperCase(); });
  };

  if (desktopSearchInput && searchDrawer) {
    const searchResults = document.getElementById('SearchContentResults');

    desktopSearchInput.addEventListener('focus', () => {
      if (headerEl) headerEl.classList.add('header--search-active');
      if (desktopSearchInput.value.trim().length < 2) {
        if (typeof window.renderPopularDefaultContent === 'function') {
          window.renderPopularDefaultContent(searchResults);
        }
        searchDrawer.classList.add('open');
      }
    });

    desktopSearchInput.addEventListener('input', () => {
      const query = desktopSearchInput.value.trim();
      const cfg = getSearchLocaleConfig();
      clearTimeout(desktopSearchTimeout);

      if (query.length < 2) {
        if (typeof window.renderPopularDefaultContent === 'function') {
          window.renderPopularDefaultContent(searchResults);
        }
        searchDrawer.classList.add('open');
        return;
      }

      desktopSearchTimeout = setTimeout(() => {
        fetch(cfg.suggestApiUrl + '?q=' + encodeURIComponent(query) + '&resources[type]=query,product&resources[limit]=10')
          .then(res => res.json())
          .then(data => {
            let queries = (data.resources.results.queries || []).slice(0, 5);
            const products = (data.resources.results.products || []).slice(0, 3);

            // Fallback: If Shopify predictive search returns 0 queries, auto-generate suggestions from product titles
            if (queries.length === 0 && products.length > 0) {
              const extracted = [];
              const lowQuery = query.toLowerCase();
              
              products.forEach(p => {
                const words = p.title.split(/\s+/);
                words.forEach((word, idx) => {
                  const cleanWord = word.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "").trim();
                  if (!cleanWord || cleanWord.length < 2) return;
                  
                  if (cleanWord.toLowerCase().indexOf(lowQuery) !== -1) {
                    const origWord = cleanWord.charAt(0).toUpperCase() + cleanWord.slice(1).toLowerCase();
                    const baseWord = cfg.isEn 
                      ? origWord 
                      : origWord.replace(/Sandalyesi$/i, 'Sandalye')
                                .replace(/Koltuğu$/i, 'Koltuk')
                                .replace(/Masası$/i, 'Masa')
                                .replace(/Sehpası$/i, 'Sehpa')
                                .replace(/Aynası$/i, 'Ayna');
                                           
                    if (extracted.indexOf(baseWord) === -1) {
                      extracted.push(baseWord);
                    }
                    
                    if (idx > 0) {
                      const prevWord = words[idx - 1].replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "").trim();
                      if (prevWord.length > 2) {
                        const compound = prevWord.charAt(0).toUpperCase() + prevWord.slice(1).toLowerCase() + ' ' + origWord.toLowerCase();
                        if (extracted.indexOf(compound) === -1) {
                          extracted.push(compound);
                        }
                      }
                    }
                  }
                });
              });
              
              queries = extracted.slice(0, 5).map(k => {
                return {
                  text: k,
                  url: cfg.searchUrl + '?q=' + encodeURIComponent(k)
                };
              });
            }

            if (queries.length === 0 && products.length === 0) {
              if (searchResults) {
                searchResults.innerHTML = '<p style="color: #666; font-size: 13px; font-family: var(--sans);">' + (cfg.isEn ? 'No results found.' : 'Sonuç bulunamadı.') + '</p>';
              }
              searchDrawer.classList.add('open');
              return;
            }

            var html = '<div class="search-results-container">';
            
            // 1. SUGGESTIONS
            if (queries.length > 0) {
              html += '<div class="search-suggestions-col" style="display: flex; flex-direction: column; gap: 4px; text-align: left; padding-bottom: 12px;">' +
                '<h4 style="font-family: var(--serif), Georgia, serif; font-style: italic; text-transform: uppercase; font-size: 11px; letter-spacing: 0.15em; color: #888; margin: 0 0 6px 0;">' + (cfg.isEn ? 'Suggestions' : 'Öneriler') + '</h4>' +
                queries.map(q => {
                  const displayQuery = window.cleanSearchQuery(q.text);
                  const qUrl = q.url.startsWith('/') && cfg.rootUrl && !q.url.startsWith(cfg.rootUrl) ? cfg.rootUrl + q.url : q.url;
                  return '<a href="' + qUrl + '" style="font-family: var(--sans), sans-serif; font-size: 14px; color: #1c1a17; text-decoration: none; padding: 5px 0; display: block; font-weight: 400; letter-spacing: 0.02em; transition: opacity 0.2s ease;">' + displayQuery + '</a>';
                }).join('') +
                '<a href="' + cfg.searchUrl + '?q=' + encodeURIComponent(query) + '" style="font-family: var(--sans), sans-serif; font-size: 11px; font-weight: 600; letter-spacing: 0.12em; text-transform: uppercase; text-decoration: underline; color: #1c1a17; margin-top: 12px; display: inline-block;">' + (cfg.isEn ? 'See All Results' : 'Tüm Sonuçları Göster') + '</a>' +
              '</div>';
            }

            // 2. PRODUCTS
            if (products.length > 0) {
              html += '<div class="search-products-col" style="display: flex; flex-direction: column; gap: 12px; text-align: left; border-top: 1px solid rgba(0,0,0,0.06); padding-top: 16px; flex-grow: 1;">' +
                '<h4 style="font-family: var(--serif), Georgia, serif; font-style: italic; text-transform: uppercase; font-size: 11px; letter-spacing: 0.15em; color: #888; margin: 0 0 8px 0;">' + (cfg.isEn ? 'Products' : 'Ürünler') + '</h4>' +
                '<div class="search-products-grid" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px;">' +
                products.map(item => {
                  const itemUrl = item.url.startsWith('/') && cfg.rootUrl && !item.url.startsWith(cfg.rootUrl) ? cfg.rootUrl + item.url : item.url;
                  return '<a href="' + itemUrl + '" style="display: flex; flex-direction: column; gap: 6px; text-decoration: none; color: inherit; position: relative;">' +
                    '<div style="aspect-ratio: 1; overflow: hidden; background: #faf8f5; border-radius: 2px;">' +
                      '<img src="' + (item.image || '') + '" alt="' + escapeHtml(item.title) + '" style="width: 100%; height: 100%; object-fit: cover;" />' +
                    '</div>' +
                    '<div style="display: flex; flex-direction: column; gap: 2px;">' +
                      '<span style="font-size: 12px; font-weight: 400; color: #1c1a17; font-family: var(--sans); line-height: 1.4;">' + escapeHtml(item.title) + '</span>' +
                      '<span style="font-size: 11px; font-weight: 600; color: var(--ink-soft); font-family: var(--sans);">' + (item.price ? '₺' + parseFloat(item.price).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '') + '</span>' +
                    '</div>' +
                  '</a>';
                }).join('') +
                '</div>' +
              '</div>';
            }

            html += '</div>';
            if (searchResults) {
              searchResults.innerHTML = html;
            }
            searchDrawer.classList.add('open');
          })
          .catch(err => {
            console.error('Desktop predictive search error:', err);
          });
      }, 200);
    });
  }

  if (searchDrawer) {
    if (closeSearchBtn) {
      closeSearchBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        searchDrawer.classList.remove('open');
        if (headerEl) headerEl.classList.remove('header--search-active');
      });
    }
    searchDrawer.addEventListener('click', (event) => {
      if (event.target === searchDrawer) {
        searchDrawer.classList.remove('open');
        if (headerEl) headerEl.classList.remove('header--search-active');
      }
    });
  }

  // ── Favorites ─────────────────────────────────────────────
  const wishlistKey = 'tarzi-hayal-wishlist';
  const readWishlist = () => {
    try { return JSON.parse(localStorage.getItem(wishlistKey) || '[]'); } catch (error) { return []; }
  };
  const syncWishlistButtons = () => {
    const ids = new Set(readWishlist().map(item => item.id));
    document.querySelectorAll('[data-wishlist-toggle]').forEach(button => {
      const active = ids.has(button.dataset.wishlistId);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? 'Favorilerden çıkar' : 'Favorilere ekle');
      
      // Update text dynamically for cart save later button
      if (button.classList.contains('cart-save-later-btn')) {
        button.textContent = active ? 'Favorilerimde' : 'Favorilere Kaydet';
      }
    });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    const item = { id: button.dataset.wishlistId, title: button.dataset.wishlistTitle, url: button.dataset.wishlistUrl, image: button.dataset.wishlistImage, price: button.dataset.wishlistPrice };
    const wishlist = readWishlist();
    const index = wishlist.findIndex(saved => saved.id === item.id);
    if (index >= 0) wishlist.splice(index, 1); else wishlist.push(item);
    localStorage.setItem(wishlistKey, JSON.stringify(wishlist));
    syncWishlistButtons();
    document.dispatchEvent(new CustomEvent('wishlist:updated'));
  });
  syncWishlistButtons();
  window.syncWishlistButtons = syncWishlistButtons;

  // Collection filter menus use Shopify-generated URLs and native details.
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!details.matches?.('.plp-filter-details') || !details.open) return;
    document.querySelectorAll('.plp-filter-details[open]').forEach((other) => {
      if (other !== details) other.removeAttribute('open');
    });
  }, true);
  document.addEventListener('click', (event) => {
    if (event.target.closest('.plp-filter-details')) return;
    document.querySelectorAll('.plp-filter-details[open]').forEach((details) => {
      details.removeAttribute('open');
    });
  });

  // ── Arhaus-Style Category Slider ───────────────────────────
  const catsTrack = document.getElementById('catsTrack');
  const catsPrevBtn = document.getElementById('catsPrevBtn');
  const catsNextBtn = document.getElementById('catsNextBtn');

  if (catsTrack) {
    const updateNavButtons = () => {
      const scrollLeft = catsTrack.scrollLeft;
      const maxScroll = catsTrack.scrollWidth - catsTrack.clientWidth;
      
      if (catsPrevBtn) {
        if (scrollLeft <= 5) {
          catsPrevBtn.classList.add('disabled');
        } else {
          catsPrevBtn.classList.remove('disabled');
        }
      }
      
      if (catsNextBtn) {
        if (scrollLeft >= maxScroll - 5) {
          catsNextBtn.classList.add('disabled');
        } else {
          catsNextBtn.classList.remove('disabled');
        }
      }
    };

    catsTrack.addEventListener('scroll', updateNavButtons);
    window.addEventListener('resize', updateNavButtons);
    const resetCategorySlider = () => {
      catsTrack.scrollLeft = 0;
      updateNavButtons();
    };
    window.addEventListener('pageshow', resetCategorySlider);
    requestAnimationFrame(resetCategorySlider);
    updateNavButtons();

    const getScrollAmount = () => {
      const card = catsTrack.querySelector('.cat-card');
      const cardWidth = card ? card.offsetWidth + 20 : 320;
      return cardWidth * 2;
    };

    if (catsPrevBtn) {
      catsPrevBtn.addEventListener('click', () => {
        catsTrack.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }

    if (catsNextBtn) {
      catsNextBtn.addEventListener('click', () => {
        catsTrack.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }

    // Drag-to-scroll support for Desktop
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let hasDragged = false;

    catsTrack.addEventListener('mousedown', (e) => {
      isDown = true;
      hasDragged = false;
      catsTrack.classList.add('dragging');
      startX = e.pageX - catsTrack.offsetLeft;
      scrollLeft = catsTrack.scrollLeft;
    });

    const stopDragging = () => {
      if (!isDown) return;
      isDown = false;
      catsTrack.classList.remove('dragging');
    };

    catsTrack.addEventListener('mouseleave', stopDragging);
    catsTrack.addEventListener('mouseup', stopDragging);

    catsTrack.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      const x = e.pageX - catsTrack.offsetLeft;
      const walk = (x - startX) * 1.6;
      if (Math.abs(walk) > 5) {
        hasDragged = true;
      }
      catsTrack.scrollLeft = scrollLeft - walk;
    });

    catsTrack.addEventListener('click', (e) => {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
        hasDragged = false;
      }
    }, true);
  }

  // ── Auto-render Recently Viewed Grids ────────────────────
  if (typeof window.renderRecentlyViewed === 'function') {
    window.renderRecentlyViewed('searchRvGrid', 'searchRecentlyViewed');
    window.renderRecentlyViewed('pdpRvGrid', 'pdpRecentlyViewed');
    window.renderRecentlyViewed('colRvGrid', 'colRecentlyViewed');
    window.renderRecentlyViewed('cartRvGrid', 'cartRecentlyViewed');
  }
  window.submitMainProductForm = function() {
    const form = document.getElementById('MainAddToCartForm') || document.querySelector('form[action*="/cart/add"]');
    if (form) {
      const btn = form.querySelector('[type="submit"]') || form.querySelector('button');
      if (btn) btn.click();
    }
  };

  // ── AJAX Newsletter Form Submission ───────────────────────
  const nlEmail = document.getElementById('footNlEmail');
  const nlBtn = document.getElementById('footNlBtn');
  const nlBox = document.querySelector('.foot-nl-box');

  if (nlEmail && nlBtn && nlBox) {
    const successDiv = nlBox.querySelector('.foot-nl-success');
    const inputWrapper = nlBox.querySelector('.foot-input-wrapper');

    const handleSubscribe = () => {
      const emailVal = nlEmail.value.trim();
      if (!emailVal || !nlEmail.checkValidity()) {
        nlEmail.reportValidity();
        return;
      }
      // Prepare request data
      const formData = new FormData();
      formData.append('form_type', 'customer');
      formData.append('utf8', '✓');
      formData.append('contact[email]', emailVal);
      formData.append('contact[tags]', 'newsletter');
      formData.append('contact[accepts_marketing]', 'true');

      // Submit asynchronously
      fetch('/contact', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Server error');
        }
        if (inputWrapper) inputWrapper.style.display = 'none';
        if (successDiv) {
          successDiv.style.display = 'block';
          successDiv.style.opacity = '0';
          setTimeout(() => {
            successDiv.style.transition = 'opacity 0.4s ease';
            successDiv.style.opacity = '1';
          }, 40);
        }
      })
      .catch(err => {
        console.warn('Newsletter submit failed:', err);
        alert('Bültene kayıt olurken bir hata oluştu. Lütfen e-posta adresinizi kontrol edip tekrar deneyin.');
      });
    };

    nlBtn.addEventListener('click', handleSubscribe);
    nlEmail.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        handleSubscribe();
      }
    });
  }

});

// ── PLP Grid Column Switcher (shared utility) ─────────────────
/**
 * Switches the PLP grid column count.
 * @param {number} cols - Number of columns (2, 3, or 4)
 */
function setPlpGrid(cols) {
  const grid = document.getElementById('plpGrid');
  if (!grid) return;
  grid.classList.remove('cols-2', 'cols-3', 'cols-4');
  grid.classList.add('cols-' + cols);
}

// ── Recently Viewed Renderer ──────────────────────────────────
/**
 * Renders recently viewed products saved in localStorage.
 * @param {string} gridId - Target grid element ID ('searchRvGrid', 'pdpRvGrid', etc.)
 */
window.renderRecentlyViewed = function (gridId, sectionId) {
  var grid = document.getElementById(gridId);
  if (!grid) return;

  try {
    var key = 'tarzi-hayal-recently-viewed';
    var rawItems = JSON.parse(localStorage.getItem(key) || '[]');
    if (!Array.isArray(rawItems)) rawItems = [];

    // Filter out invalid, empty, or corrupted entries
    var items = rawItems.filter(function (p) {
      return p && p.title && p.url && p.featured_image && p.featured_image !== 'undefined' && p.featured_image !== 'null' && String(p.featured_image).trim() !== '';
    });

    if (items.length === 0) {
      if (sectionId) {
        var sec = document.getElementById(sectionId);
        if (sec) sec.style.display = 'none';
      }
      return;
    }

    var currentHandle = grid.dataset.currentProduct;
    if (currentHandle) {
      items = items.filter(function (p) { return p.handle !== currentHandle; });
    }

    if (items.length === 0) {
      if (sectionId) {
        var sec = document.getElementById(sectionId);
        if (sec) sec.style.display = 'none';
      }
      return;
    }

    // Show section if we have items
    if (sectionId) {
      var sec = document.getElementById(sectionId);
      if (sec) sec.style.display = 'block';
    }

    var html = '';
    var isSlider = grid.classList.contains('cart-rv-track');
    var displayItems = items.slice(0, isSlider ? 8 : 4);

    displayItems.forEach(function (item) {
      var compareHtml = item.compare_at_price
        ? '<s class="pc-compare-price">' + item.compare_at_price + '</s> <span class="pc-price pc-price--sale">' + item.price + '</span>'
        : '<span class="pc-price">' + item.price + '</span>';

      var badgeHtml = item.is_new ? '<span class="pc-badge-new" aria-label="Yeni ürün">New</span>' : '';
      var secondaryImgHtml = item.secondary_image
        ? '<img src="' + item.secondary_image + '" alt="' + escapeHtml(item.title) + '" loading="lazy" class="pc-img pc-img--secondary">'
        : '';
      var promoHtml = item.compare_at_price ? '<div class="pc-promo-bar">İNDİRİM — FIRSATI KAÇIRMA</div>' : '';

      // Fix Turkish casing in JS using toLocaleUpperCase('tr-TR') for browser compatibility
      var displayTitle = escapeHtml((item.title || '').toLocaleUpperCase('tr-TR'));

      var cardHtml = '<article class="pc-card" aria-label="' + escapeHtml(item.title) + '">'
        + '<div class="pc-img-wrap">'
        + '<a href="' + item.url + '" class="pc-img-link">'
        + '<img src="' + item.featured_image + '" alt="' + escapeHtml(item.title) + '" loading="lazy" class="pc-img pc-img--primary">'
        + secondaryImgHtml
        + '</a>'
        + badgeHtml
        + '</div>'
        + '<button type="button" class="pc-wishlist-btn" data-wishlist-toggle data-wishlist-id="' + item.handle + '" data-wishlist-title="' + escapeHtml(item.title) + '" data-wishlist-url="' + item.url + '" data-wishlist-image="' + item.featured_image + '" data-wishlist-price="' + item.price + '" aria-label="Favorilere ekle" aria-pressed="false">'
        + '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z"/></svg>'
        + '</button>'
        + '<div class="pc-body">'
        + '<h3 class="pc-title"><a href="' + item.url + '" lang="tr" style="text-transform: uppercase;">' + displayTitle + '</a></h3>'
        + '<div class="pc-price-row">' + compareHtml + '</div>'
        + promoHtml
        + '</div>'
        + '</article>';

      if (isSlider) {
        html += '<div class="cart-rv-item">' + cardHtml + '</div>';
      } else {
        html += cardHtml;
      }
    });

    grid.innerHTML = html;
    
    // Sync new buttons' state
    if (typeof window.syncWishlistButtons === 'function') {
      window.syncWishlistButtons();
    }
    
    // Initialize drag scroll on dynamic render
    if (typeof window.initDragToScroll === 'function' && grid.parentElement) {
      window.initDragToScroll(grid.parentElement);
    }
  } catch (e) {
    console.warn('Render recently viewed error:', e);
  }
};

// ── Mobile Bottom Nav Scroll Behaviour (Global Scope) ──
(function() {
  function initMobileNavScroll() {
    const mobileNav = document.getElementById('mobileBottomNav');
    if (!mobileNav) return;

    let lastScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
    
    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
      
      if (currentScrollY > lastScrollY && currentScrollY > 40) {
        // Scrolling down: shrink
        mobileNav.classList.add('scrolled-down');
      } else if (currentScrollY < lastScrollY) {
        // Scrolling up: expand
        mobileNav.classList.remove('scrolled-down');
      }

      if (currentScrollY <= 10) {
        mobileNav.classList.remove('scrolled-down');
      }
      
      lastScrollY = currentScrollY;
    }, { passive: true });
  }

  // Mouse drag-to-scroll utility for horizontal carousels on desktop
  window.initDragToScroll = function(slider) {
    if (!slider || slider.dataset.dragInitialized) return;
    slider.dataset.dragInitialized = 'true';

    let isDown = false;
    let startX;
    let scrollLeft;
    let hasMoved = false;

    // Prevent default browser image/link dragging (ghost image preview)
    slider.addEventListener('dragstart', (e) => {
      e.preventDefault();
    });

    slider.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return; // Left click only
      isDown = true;
      hasMoved = false;
      slider.classList.add('is-dragging');
      slider.style.scrollSnapType = 'none';
      slider.style.scrollBehavior = 'auto';
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      if (!isDown) return;
      isDown = false;
      slider.classList.remove('is-dragging');
      slider.style.scrollSnapType = 'x mandatory';
      slider.style.scrollBehavior = 'smooth';
    });

    slider.addEventListener('mouseup', () => {
      if (!isDown) return;
      isDown = false;
      slider.classList.remove('is-dragging');
      slider.style.scrollSnapType = 'x mandatory';
      slider.style.scrollBehavior = 'smooth';
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5;
      if (Math.abs(walk) > 5) {
        hasMoved = true;
      }
      slider.scrollLeft = scrollLeft - walk;
    });

    // Prevent click links if dragged
    slider.addEventListener('click', (e) => {
      if (hasMoved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  };

  function updateHeaderHeightVar() {
    const header = document.getElementById('header');
    if (header) {
      document.documentElement.style.setProperty('--header-height-current', header.offsetHeight + 'px');
    }
  }

  // Applies a re-rendered cart-drawer section (fetched via the Section
  // Rendering API's `sections=cart-drawer` param) into the live DOM, instead
  // of re-fetching and parsing the entire current page just to pull the
  // drawer's markup out of it.
  function applyCartDrawerSection(sectionsHtml) {
    const newDrawerHtml = sectionsHtml && sectionsHtml['cart-drawer'];
    if (!newDrawerHtml) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(newDrawerHtml, 'text/html');
    const newDrawer = doc.getElementById('cartDrawerPanel');
    const currentDrawer = document.getElementById('cartDrawerPanel');
    if (newDrawer && currentDrawer) {
      currentDrawer.innerHTML = newDrawer.innerHTML;

      const closeTriggers = currentDrawer.querySelectorAll('[data-action="close-cart"]');
      if (closeTriggers.length > 0 && typeof window.closeCartDrawer === 'function') {
        closeTriggers.forEach(btn => btn.addEventListener('click', window.closeCartDrawer));
      }
    }
  }

  function updateCartBadge(itemCount) {
    const currentBadge = document.querySelector('.header-cart-badge');
    const cartLink = document.querySelector('.mobile-cart-header');
    if (itemCount > 0) {
      if (currentBadge) {
        currentBadge.textContent = itemCount;
      } else if (cartLink) {
        const badgeSpan = document.createElement('span');
        badgeSpan.className = 'header-cart-badge';
        badgeSpan.textContent = itemCount;
        cartLink.appendChild(badgeSpan);
      }
    } else if (currentBadge) {
      currentBadge.remove();
    }
  }

  // Fallback path only: re-fetch the drawer + badge the old (expensive) way,
  // used when a request didn't/couldn't ask for sections=cart-drawer.
  function refreshCartDrawer() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        updateCartBadge(cart.item_count);
      });
  }

  function initAjaxAddToCart() {
    const forms = document.querySelectorAll('form[action$="/cart/add"]');
    forms.forEach(form => {
      if (form.dataset.ajaxAtcBound) return;
      form.dataset.ajaxAtcBound = 'true';

      form.addEventListener('submit', (e) => {
        e.preventDefault();
        
        const submitBtn = form.querySelector('button[type="submit"]');
        const submitTextEl = submitBtn ? submitBtn.querySelector('span') : null;
        const originalText = submitTextEl ? submitTextEl.textContent : (submitBtn ? submitBtn.textContent : '');

        if (submitBtn) {
          submitBtn.disabled = true;
          if (submitTextEl) submitTextEl.textContent = 'EKLENİYOR...';
          else submitBtn.textContent = 'EKLENİYOR...';
        }

        const formData = new FormData(form);

        fetch('/cart/add.js?sections=cart-drawer', {
          method: 'POST',
          body: formData
        })
        .then(response => {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(data => {
          applyCartDrawerSection(data.sections);
          // /cart/add.js only returns the added line item, not the cart
          // totals, so the badge count still needs a light /cart.js read.
          return refreshCartDrawer();
        })
        .then(() => {
          if (submitBtn) {
            submitBtn.disabled = false;
            if (submitTextEl) submitTextEl.textContent = originalText;
            else submitBtn.textContent = originalText;
          }

          if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();
          }
        })
        .catch(err => {
          console.warn('AJAX add to cart failed, falling back to form submit:', err);
          if (submitBtn) {
            submitBtn.disabled = false;
            if (submitTextEl) submitTextEl.textContent = originalText;
            else submitBtn.textContent = originalText;
          }
          form.submit();
        });
      });
    });

    // Intercept quantity buttons (+ / -) and Remove clicks inside Cart Drawer via Event Delegation
    document.addEventListener('click', (e) => {
      const qtyBtn = e.target.closest('.cd-qty-btn');
      const removeBtn = e.target.closest('.cd-item-remove');

      if (qtyBtn || removeBtn) {
        e.preventDefault();
        const targetLink = qtyBtn || removeBtn;
        const line = targetLink.getAttribute('data-line');
        const quantity = targetLink.getAttribute('data-quantity');
        const url = targetLink.getAttribute('href');
        if (!line || quantity === null) return;

        const itemsContainer = document.getElementById('cdItems');
        if (itemsContainer) {
          itemsContainer.style.opacity = '0.5';
          itemsContainer.style.pointerEvents = 'none';
        }

        // One lightweight round trip: /cart/change.js returns the full
        // updated cart (for the badge count) *and*, via sections=, the
        // freshly rendered drawer markup — no full-page fetch needed.
        fetch('/cart/change.js?sections=cart-drawer', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
        })
          .then(response => response.json())
          .then(cart => {
            applyCartDrawerSection(cart.sections);
            updateCartBadge(cart.item_count);
          })
          .then(() => {
            if (itemsContainer) {
              itemsContainer.style.opacity = '';
              itemsContainer.style.pointerEvents = '';
            }
          })
          .catch(err => {
            console.warn('Cart update failed, navigating to URL:', err);
            if (url) window.location.href = url;
          });
      }
    });
  }

  function initAllSliders() {
    initMobileNavScroll();
    updateHeaderHeightVar();
    initAjaxAddToCart();
    
    // Auto-init currently existing sliders
    document.querySelectorAll('.cart-rv-scroll').forEach(function(slider) {
      window.initDragToScroll(slider);
    });
  }

  window.addEventListener('resize', updateHeaderHeightVar);
  window.addEventListener('scroll', updateHeaderHeightVar, { passive: true });
  window.addEventListener('load', updateHeaderHeightVar);

  // Run immediately (script is deferred, so DOM elements are available)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders);
  } else {
    initAllSliders();
  }
})();
